import { FC, ReactElement, useEffect, useMemo, useRef } from 'react';
import {
  useStepForm,
  StepChildProps,
  useStepFormParams,
} from '@oresundsbron/use-form';
import { Box } from '@oresundsbron/bridge-ui';

type MultiStepFormProps = {
  children: ReactElement<StepChildProps> | ReactElement<StepChildProps>[];
  onSubmit: useStepFormParams['onSubmit'];
  continueLabel: string;
  submitLabel: string;
  editLabel: string;
  push?: (url: string) => Promise<boolean | void>;
};

export const MultiStepForm: FC<MultiStepFormProps> = ({
  children,
  onSubmit,
  continueLabel,
  editLabel,
  submitLabel,
  push,
}) => {
  const { visibleChildren, handleSubmit, setLabels, activeStep } = useStepForm({
    onSubmit,
    children,
  });

  const lastActive = useRef('');

  useMemo(
    () => setLabels(continueLabel, submitLabel, editLabel),
    [continueLabel, editLabel, setLabels, submitLabel]
  );

  useEffect(() => {
    const fn = async () => {
      if (visibleChildren.length === 1) {
        return;
      }

      if (lastActive.current === activeStep) {
        return;
      }

      push && (await push(`#${activeStep}`));

      lastActive.current = activeStep;
    };

    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  return (
    <Box as="form" onSubmit={handleSubmit}>
      {visibleChildren}
    </Box>
  );
};
